<section class="bg-white  shadow p-4 md:p-6">
  <h2 class="font-semibold uppercase text-xl sm:text-2xl md:text-3xl text-gray-900 mb-3">Programação</h2>
  <p class="border-4 w-full border-black mb-4"></p>

  <ul class="divide-y">
    <li *ngFor="let it of items; trackBy: track" class="py-3 flex items-start gap-4">
      <div class="font-bold rounded-md p-1 bg-black text-white flex justify-center w-16">{{ it.time }}</div>
      <div class="flex-1">
        <div class="font-semibold text-gray-900">{{ it.title }}</div>
        <div class="text-sm text-gray-600" *ngIf="it.description">{{ it.description }}</div>
      </div>
    </li>
  </ul>
</section>